export default __webpack_public_path__ + "static/media/77_Agent_Sunny_header_return.e6f368db.png";